import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
import axios from "axios";
import { ItemsList } from "../../Components/MissedOpportunities";
import withRoutes from "../../HOC/HocRoutes";
import moment from "moment-timezone";

let source;
let detailSource;

class MissedOpportunities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      to: "",
      from: "",
      selectedUser: "",
      status: "",
      page: 1,
      pageSize: 20,
      searchItem: "",
      value: "maintenance",
      invoiceData: "",
      searchInvoiceText: "",
      selectedAccount: "",
      selectSingleInvoice: false,
      leasing: false,
      showPayments: false,
      recievingPartyAccounts: [],
      contractType: 1,
      loader1: false,
      loader2: false,
      selectSingleAccount: false,
      itemsData: [],
      checkUser: true,
      tab: "missedOpportunity",
      overDueRangeEnabled: true,
      dueRangeEnabled: true,
      plateNo: "",
      category: "",
      itemCode: "",
      completed: 0,
      wanted: 1,
      expandedGroups: {},
      groupDetails: {},
      groupDetailsLoading: {},
    };
  }

  appendOpportunityFilters = (url, { includePlateNo = true } = {}) => {
    const { plateNo, category, itemCode, completed, wanted } = this.state;
    if (includePlateNo && plateNo) {
      url += `&plateNo=${encodeURIComponent(plateNo)}`;
    }
    if (category) url += `&category=${encodeURIComponent(category)}`;
    if (itemCode) url += `&itemCode=${encodeURIComponent(itemCode)}`;
    if (completed !== "" && completed !== null && completed !== undefined) {
      url += `&completed=${completed}`;
    }
    if (wanted !== "" && wanted !== null && wanted !== undefined) {
      url += `&wanted=${wanted}`;
    }
    return url;
  };

  getPredictionStatus = () => (this.state.tab === "missedOpportunity" ? 1 : 2);

  getGroupKey = (group) =>
    `${group.contractNumber || group.cn || ""}_${group.plateNumber || group.plateNo || ""}`;

  appendCnFilter = (url) => {
    const { selectedUser } = this.state;
    if (!selectedUser || typeof selectedUser !== "string") {
      return url;
    }
    return (
      url +
      (selectedUser.startsWith("&") ? selectedUser : `&cn=${selectedUser}`)
    );
  };

  resetGroupedState = () => ({
    expandedGroups: {},
    groupDetails: {},
    groupDetailsLoading: {},
  });

  getAppTimezone = () => {
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      return this.props.logInUser.attributes.timezone;
    }
    if (
      this.props.ServerSetting &&
      this.props.ServerSetting.attributes &&
      this.props.ServerSetting.attributes.timezone
    ) {
      return this.props.ServerSetting.attributes.timezone;
    }
    return "Asia/Riyadh";
  };

  getDefaultDateRangeForTab = (tab) => {
    const timezone = this.getAppTimezone();
    moment.tz.setDefault(timezone);

    if (tab === "missedOpportunity") {
      return {
        from: moment().subtract(30, "days").startOf("day").toISOString(),
        to: moment().endOf("day").toISOString(),
      };
    }

    if (tab === "potentialOpportunity") {
      return {
        from: moment().startOf("day").toISOString(),
        to: moment().add(30, "days").endOf("day").toISOString(),
      };
    }

    return { from: "", to: "" };
  };

  isDefaultRangeAligned = (tab, fromValue, toValue) => {
    if (!fromValue || !toValue) return false;
    const expected = this.getDefaultDateRangeForTab(tab);
    const fromDiff = Math.abs(
      new Date(fromValue).getTime() - new Date(expected.from).getTime(),
    );
    const toDiff = Math.abs(
      new Date(toValue).getTime() - new Date(expected.to).getTime(),
    );
    // allow tiny client timing differences
    return fromDiff <= 1000 && toDiff <= 1000;
  };

  applyDefaultDateRangeForTab = (tab, callback) => {
    const shouldApply =
      (tab === "missedOpportunity" && this.state.overDueRangeEnabled) ||
      (tab === "potentialOpportunity" && this.state.dueRangeEnabled);

    if (!shouldApply) {
      this.setState(
        {
          from: "",
          to: "",
        },
        () => callback && callback(),
      );
      return;
    }

    const range = this.getDefaultDateRangeForTab(tab);
    this.setState(
      {
        from: range.from || "",
        to: range.to || "",
      },
      () => callback && callback(),
    );
  };

  componentWillMount() {
    this.applyDefaultDateRangeForTab(this.state.tab, () => {
      this.getMissingItems();
    });
    // this.getContractsData();
  }

  // componentWillReceiveProps (n) {
  //   if(this.props.logInUser && this.state.checkUser){
  //       this.getContractsData();
  //     }
  // }

  searchInvoiceText = (e) => {
    source.cancel();
    this.setState(
      {
        searchInvoiceText: e.target.value,
      },
      () => {
        // this.getContractsData();
      },
    );
  };

  setPagination = () => {
    let nAcc;
    // if (this.state.selectSingleAccount) {
    nAcc = { ...this.state.itemsData }; // for   Missing Items
    // } else {
    //   nAcc = { ...this.state.invoiceData }; // for contract All accounts
    // }
    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  handleChangePage = (value) => {
    // if (this.state.selectSingleAccount) {
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        status: this.state.status,
        page: value,
      },
      () => this.getMissingItems(),
    );
    // } else {
    //   this.setState({ page: value }, () => this.getContractsData()); // for contract All accounts
    // }
  };

  handleChangeRowsPerPage = (value) => {
    // if (this.state.selectSingleAccount) {
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        status: this.state.status,
        pageSize: value,
        page: 1,
      },
      () => this.getMissingItems(),
    );
    // } else {
    //   this.setState({ pageSize: value }, () => this.getContractsData()); // for contract All accounts
    // }
  };

  handleChangeTabs = (e) => {
    if (e === "leasing") {
      this.setState(
        {
          value: e,
          leasing: true,
          contractType: 2,
        },
        () => {
          this.getContractsData();
        },
      );
    } else if (e === "maintenance") {
      this.setState(
        {
          value: e,
          leasing: false,
          contractType: 1,
        },
        () => {
          this.getContractsData();
        },
      );
    }
  };

  getContractsData = () => {
    let list = {};
    let usersId = {};

    let apiUrl = `/api/accounts/list?all=true&contractType=1&userId=${this.props.logInUser.id}&limit=-1&search=${this.state.searchInvoiceText}`;
    source = axios.CancelToken.source();
    this.setState(
      {
        accounts: [],
        loader1: false,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            let dataRes = response?.data?.data?.data || [];
            dataRes &&
              dataRes.map(
                (d) => (
                  (list[d.contractNumber] = true),
                  (usersId[d.userId] = true)
                ),
              );
            this.setState({
              accounts: response?.data?.data || {},
              makingAccounts: list,
              makingUsers: usersId,
              loader1: false,
              checkUser: false,
              // loaderR:true,
            });
          })
          .catch((e) => {
            console.log("e ===", e);
          });
      },
    );
  };

  // getContractsData = async () => {
  //   while (!this.props.logInUser.id) {
  //     await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for 100 milliseconds before checking again
  //   }

  //   let list = {};
  //   let usersId = {};

  //   let apiUrl = `/api/accounts/list?all=true&contractType=1&userId=${this.props.logInUser.id}&limit=-1&search=${this.state.searchInvoiceText}`;

  //   source = axios.CancelToken.source();
  //   this.setState({
  //     accounts: [],
  //     loader1: false,
  //   }, async () => {
  //     try {
  //       const response = await axios.get(apiUrl, {
  //         cancelToken: source.token,
  //       });

  //       let dataRes = response?.data?.data?.data || [];
  //       dataRes &&
  //         dataRes.map(
  //           (d) => ((list[d.contractNumber] = true), (usersId[d.userId] = true))
  //         );
  //       this.setState({
  //         accounts: response?.data?.data || {},
  //         makingAccounts: list,
  //         makingUsers: usersId,
  //         loader1: false,
  //       });
  //     } catch (e) {
  //       console.log("e ===", e);
  //     }
  //   });
  // };
  invoiceSelection = (item) => {
    this.setState(
      {
        selectedAccount: item,
        selectSingleAccount: true,
      },
      () => {
        this.getMissingItems(item.contractNumber);
      },
    );
  };

  goBack = () => {
    this.setState(
      {
        selectSingleAccount: false,
      },
      () => {
        this.getContractsData();
      },
    );
  };

  getItems = (userId, to, from, status, type) => {
    const selectedTab = this.state.tab;
    const updates = {};

    if (
      selectedTab === "missedOpportunity" &&
      this.state.overDueRangeEnabled &&
      !this.isDefaultRangeAligned(selectedTab, from, to)
    ) {
      updates.overDueRangeEnabled = false;
    }
    if (
      selectedTab === "potentialOpportunity" &&
      this.state.dueRangeEnabled &&
      !this.isDefaultRangeAligned(selectedTab, from, to)
    ) {
      updates.dueRangeEnabled = false;
    }

    this.setState(
      {
        ...updates,
        to: to,
        from: from,
        selectedUser:
          typeof userId === "string" ? userId : "",
        status: status,
        page: 1,
      },
      () => {
        if (type === "downloadExcel") {
          this.downloadCreditDebit(type);
        } else {
          this.getMissingItems();
        }
      },
    );
  };

  downloadCreditDebit = (type) => {
    let accept;
    let dateto = this.state.to || "";
    let datefrom = this.state.from || "";
    let userId = this.state.selectedUser || "";
    // let status =  this.state.status || 0;

    let status =
      this.state.tab === "missedOpportunity"
        ? 1
        : this.state.tab === "potentialOpportunity"
          ? 2
          : 0;
    if (type === "downloadPdf") {
      accept = "application/pdf";
    } else {
      accept =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }
    let header;
    header = {
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: accept,
      }),
      method: "GET",
    };

    let apiUrl;
    apiUrl = `/api/predictions/export?status=${status}`;

    if (dateto) apiUrl += `&to=${dateto}`;
    if (datefrom) apiUrl += `&from=${datefrom}`;
    if (userId && typeof userId === "string") {
      apiUrl += userId.startsWith("&") ? userId : `&cn=${userId}`;
    }
    apiUrl = this.appendOpportunityFilters(apiUrl);

    fetch(apiUrl, { ...header })
      .then((response1) => {
        if (response1.status === 200) {
          if (type === "downloadPdf") {
            response1.blob().then((response) => {
              this.setState(
                {
                  selectedAreaId: "",
                  selectedvehicleId: "",
                  page: this.state.page,
                  pageSize: this.state.pageSize,
                  to: this.state.to,
                  from: this.state.from,
                  selectedUser: this.state.selectedUser,
                  loader: false,
                },
                () => {
                  this.saveData(response, "CreditDebit.pdf");
                },
              );
            });
          } else {
            response1.blob().then((response) => {
              this.setState(
                {
                  selectedAreaId: "",
                  selectedvehicleId: "",
                  page: this.state.page,
                  pageSize: this.state.pageSize,
                  to: this.state.to,
                  from: this.state.from,
                  selectedUser: this.state.selectedUser,
                  loader: false,
                },
                () => {
                  this.saveData(response, "Missed_Opportunity.xlsx");
                },
              );
            });
          }
        } else {
          throw response1;
        }
      })

      .catch((error) => {
        // errorHandler(error, this.props.dispatch)
      });
  };

  saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    }
  };

  getMissingItems = () => {
    const { page, pageSize, to, from } = this.state;
    const status = this.getPredictionStatus();

    let apiUrl = `/api/predictions/getGrouped?page=${page}&limit=${pageSize}&status=${status}&all=true`;
    if (to) apiUrl += `&to=${to}`;
    if (from) apiUrl += `&from=${from}`;
    apiUrl = this.appendOpportunityFilters(apiUrl);
    apiUrl = this.appendCnFilter(apiUrl);

    if (source) {
      source.cancel();
    }
    source = axios.CancelToken.source();

    this.setState(
      {
        loader2: true,
        ...this.resetGroupedState(),
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              loader2: false,
              itemsData: response?.data?.data || {},
            });
          })
          .catch((e) => {
            if (!axios.isCancel(e)) {
              this.setState({ loader2: false });
            }
          });
      },
    );
  };

  fetchGroupDetails = (group, page = 1, append = false) => {
    const key = this.getGroupKey(group);
    const cn = group.contractNumber || group.cn;
    const plateNo = group.plateNumber || group.plateNo;
    const status = this.getPredictionStatus();
    const { pageSize, to, from } = this.state;

    if (!cn || !plateNo) {
      return;
    }

    if (detailSource) {
      detailSource.cancel();
    }
    detailSource = axios.CancelToken.source();

    this.setState({
      groupDetailsLoading: {
        ...this.state.groupDetailsLoading,
        [key]: true,
      },
    });

    let apiUrl = `/api/predictions/getByContractPlate?page=${page}&limit=${pageSize}&status=${status}`;
    apiUrl += `&cn=${encodeURIComponent(cn)}`;
    apiUrl += `&plateNo=${encodeURIComponent(plateNo)}`;
    if (to) apiUrl += `&to=${to}`;
    if (from) apiUrl += `&from=${from}`;
    apiUrl = this.appendOpportunityFilters(apiUrl, { includePlateNo: false });

    axios
      .get(apiUrl, { cancelToken: detailSource.token })
      .then((response) => {
        const detailData = response?.data?.data || {};
        const incomingRows = detailData.data || [];
        const previousRows = append
          ? this.state.groupDetails[key]?.data || []
          : [];

        this.setState((prev) => ({
          groupDetails: {
            ...prev.groupDetails,
            [key]: {
              data: append ? [...previousRows, ...incomingRows] : incomingRows,
              page,
              hasNext: detailData.hasNext,
              total: detailData.total,
            },
          },
          groupDetailsLoading: {
            ...prev.groupDetailsLoading,
            [key]: false,
          },
        }));
      })
      .catch((e) => {
        if (!axios.isCancel(e)) {
          this.setState((prev) => ({
            groupDetailsLoading: {
              ...prev.groupDetailsLoading,
              [key]: false,
            },
          }));
        }
      });
  };

  toggleGroup = (group) => {
    const key = this.getGroupKey(group);
    const isExpanded = !!this.state.expandedGroups[key];

    if (isExpanded) {
      this.setState({
        expandedGroups: {
          ...this.state.expandedGroups,
          [key]: false,
        },
      });
      return;
    }

    this.setState(
      {
        expandedGroups: {
          ...this.state.expandedGroups,
          [key]: true,
        },
      },
      () => {
        if (!this.state.groupDetails[key]) {
          this.fetchGroupDetails(group, 1, false);
        }
      },
    );
  };

  loadMoreGroupDetails = (group) => {
    const key = this.getGroupKey(group);
    const detail = this.state.groupDetails[key];
    if (!detail?.hasNext || this.state.groupDetailsLoading[key]) {
      return;
    }
    this.fetchGroupDetails(group, (detail.page || 1) + 1, true);
  };
  handleFilterChange = (name) => (event) => {
    let value = event.target.value;
    if (name === "completed" || name === "wanted") {
      value = parseInt(value, 10);
    }
    this.setState({ [name]: value });
  };

  applyFilters = () => {
    if (source) {
      source.cancel();
    }
    this.setState({ page: 1 }, () => this.getMissingItems());
  };

  clearFilters = () => {
    if (source) {
      source.cancel();
    }
    this.setState(
      {
        page: 1,
        plateNo: "",
        category: "",
        itemCode: "",
        completed: 0,
        wanted: 1,
        ...this.resetGroupedState(),
      },
      () => {
        this.applyDefaultDateRangeForTab(this.state.tab, () => {
          this.getMissingItems();
        });
      },
    );
  };

  handleToggleOverDueRange = (checked) => {
    this.setState({ overDueRangeEnabled: checked }, () => {
      if (this.state.tab !== "missedOpportunity") return;
      this.applyDefaultDateRangeForTab("missedOpportunity", () => {
        this.setState({ page: 1, ...this.resetGroupedState() }, () => {
          this.getMissingItems();
        });
      });
    });
  };

  handleToggleDueRange = (checked) => {
    this.setState({ dueRangeEnabled: checked }, () => {
      if (this.state.tab !== "potentialOpportunity") return;
      this.applyDefaultDateRangeForTab("potentialOpportunity", () => {
        this.setState({ page: 1, ...this.resetGroupedState() }, () => {
          this.getMissingItems();
        });
      });
    });
  };

  searchItems = (e) => {
    source.cancel();
    // console.log("e====", e,   this.state.selectedUser,);
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        status: this.state.status,
        searchItem: e.target.value,
      },
      () => {
        this.getMissingItems();
      },
    );
  };

  handleChangeTabs = (e) => {
    const tabResetState = {
      tab: e,
      page: 1,
      selectedUser: "",
      ...this.resetGroupedState(),
    };
    if (e === "missedOpportunity") {
      tabResetState.overDueRangeEnabled = true;
    }
    if (e === "potentialOpportunity") {
      tabResetState.dueRangeEnabled = true;
    }

    this.setState(tabResetState, () => {
      this.applyDefaultDateRangeForTab(e, () => {
        this.getMissingItems();
      });
    });
  };

  render() {
    if (this.props.logInUser) {
      const { value } = this.state;

      return (
        <Layout {...this.state} {...this.props} getMissingItems={this.getItems}>
          <ItemsList
            {...this.state}
            handleChangeTabs={this.handleChangeTabs}
            getMissingItems={this.getMissingItems}
            handleFilterChange={this.handleFilterChange}
            applyFilters={this.applyFilters}
            clearFilters={this.clearFilters}
            handleToggleOverDueRange={this.handleToggleOverDueRange}
            handleToggleDueRange={this.handleToggleDueRange}
            {...this.props}
            searchItems={this.searchItems}
            groupedRows={this.state.itemsData.data || []}
            setPagination={this.setPagination}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            translate={this.props.translate}
            goBack={this.goBack}
            toggleGroup={this.toggleGroup}
            loadMoreGroupDetails={this.loadMoreGroupDetails}
            expandedGroups={this.state.expandedGroups}
            groupDetails={this.state.groupDetails}
            groupDetailsLoading={this.state.groupDetailsLoading}
            getGroupKey={this.getGroupKey}
          />
          {/* :""} */}
        </Layout>
      );
    } else {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        },
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en",
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          this.props.navigate("/login");

          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
});

export default connect(mapStateToProps)(withRoutes(MissedOpportunities));
